import _ from 'underscore';
import Backbone from 'backbone';
import { SubscriptionModel } from './subscription-model';
import { SubscriptionView } from './subscription-view';
import { BoosterSubscriptionModel } from './booster-subscription-model';
import { BoosterSubscriptionView } from './booster-subscription-view';

// 클래스(부스터 포함) 페이지(membership.njk)의 클라이언트 로직:
export var MembershipView = Backbone.View.extend({
  el: '.app__membership',

  initialize: function () {
    this.subscription = null;
    this.subscriptionView = null;
    this.listenTo(this.model, 'sync', this.render);
  },

  events: {
    'click [data-ms-click=subscription]': 'manageSubscription'
  },

  // this.model = userInfo Model
  render: function () {
    /** @type {'gold' | 'silver' | 'none'} */
    var membershipName = this.model.get('membership').replace(/class$/, ''); // gold | silver | none
    var hasClassSubscription = this.model.get('hasSubscription');

    var hasBooster = this.model.get('hasBooster');
    var boosterIsSubscription = this.model.get('boosterIsSubscription');

    /** @type {'gold' | 'silver' | 'booster'} */
    var pageName = this.$el.data('msPage'); // membership.njk에서 설정한 data-ms-page 속성값

    // 클래스 정기권 구매하기, 사용중 표시
    if (membershipName === pageName && hasClassSubscription) {
      this.$('.ms-membership-using, .ms-membership-detail').show();
      this.$('.ms-membership-purchase').hide();
    } else {
      this.$('.ms-membership-using, .ms-membership-detail').hide();
      this.$('.ms-membership-purchase').show();
    }

    // 클래스 개월권 구매하기, 사용중 표시
    if (!hasClassSubscription && /gold|silver/.test(membershipName)) {
      this.$('.ms-monthly-' + membershipName)
        .find('.ms-membership-using')
        .show();
    } else {
      this.$('.ms-monthly .ms-membership-using').hide();
    }

    if (hasBooster) {
      // 부스터 정기권 이용중 표시
      if (boosterIsSubscription && pageName === 'booster') {
        this.$('.ms-membership-using, .ms-membership-detail').show();
        this.$('.ms-membership-purchase').hide();
      }

      // 부스터 개월권 이용중 표시
      if (!boosterIsSubscription && pageName === 'monthly') {
        this.$('.ms-monthly-booster').find('.ms-membership-using').show();
      }
    }

    return this;
  },

  manageSubscription: function (e) {
    if (e && _.isFunction(e.preventDefault)) {
      e.preventDefault();
    }

    if (this.subscriptionView) {
      this.subscription = null;
      this.subscriptionView.remove();
    }

    var isBooster = this.$el.data('msPage') === 'booster';

    if (isBooster) {
      // 부스터 정기결제 관리 페이지
      this.subscription = new BoosterSubscriptionModel();
      this.subscriptionView = new BoosterSubscriptionView({ model: this.subscription });
    } else {
      // 클래스(골드, 실버) 정기결제 관리 페이지
      this.subscription = new SubscriptionModel();
      this.subscriptionView = new SubscriptionView({ model: this.subscription });
    }

    var rendered = this.subscriptionView.el;
    $('.app__subscription').html(rendered);
  }
});
